import React from 'react';
import { POLICY_SECTIONS, type PolicyBlock } from './policySections';

function renderBlocks(blocks: PolicyBlock[]): React.ReactNode {
  return blocks.map((section) => (
    <React.Fragment key={section.heading}>
      <h2>{section.heading}</h2>
      {section.paragraphs.map((paragraph) => (
        <p key={paragraph}>{paragraph}</p>
      ))}
      {section.list ? (
        <ul>
          {section.list.map((item) => (
            <li key={`${item.label || ''}${item.text}`}>
              {item.label ? <strong>{item.label} </strong> : null}
              {item.text}
            </li>
          ))}
        </ul>
      ) : null}
    </React.Fragment>
  ));
}

export const PolicyBody: React.FC<{ kind: 'privacy' | 'terms'; language: 'en' | 'es' }> = ({ kind, language }) => (
  <>{renderBlocks(POLICY_SECTIONS[kind][language])}</>
);
